import React, { useEffect, useState } from "react";
import { useGlobalContext } from "../../../Context/GlobalContext";
import Cookies from "js-cookie";
const UserPermission = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [allRoles, setAllRoles] = useState([]);
  const [allDepartments, setAllDepartments] = useState([]);
  const { selectedStaff } = useGlobalContext();

  const { baseUrl, openToast } = useGlobalContext();
  const [role, setRole] = useState("");
  const [department, setDepartment] = useState("");
  const [departmentID, setDepartmentID] = useState("");
  const [roleID, setRoleID] = useState("");
  console.log(selectedStaff);
  const [allBranch, setAllBranch] = useState();
  const [branch, setBranch] = useState("");
  const [branchID, setBranchID] = useState("");
  const fetchBranch = async (e) => {
    try {
      const response = await fetch(baseUrl + "branch/", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`

        },
      });

      if (response.status === 200) {
        const result = await response.json();
        setAllBranch(result);
        console.log("Filtered data by ID:", result);

        console.log("Data retrieved successfully:", result);
        // navigate("/admin/staff");
      } else {
        console.error(
          "Failed to retrieve data:",
          response.status,
          response.statusText
        );
      }
    } catch (error) {
      console.error("An error occurred while fetching data:", error);
    }
  };

  const fetchDepartments = async () => {
    const result = await fetch(baseUrl + "department", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`
      }
    });
    if (result.status == 200) {
      const res = await result.json();
      setAllDepartments(res.data);
    } else {
      alert("An Error Occured");
    }
  };

  const fetchRoles = async () => {
    const result = await fetch(baseUrl + "role", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`
      }
    });
    if (result.status == 200) {
      const res = await result.json();
      setAllRoles(res.data);
    } else {
      alert("An Error Occured");
    }
    console.log("result", result);
  };

  console.log(allBranch);
  useEffect(() => {
    fetchDepartments();
    fetchRoles();
    fetchBranch();
    setBranchID(selectedStaff?.branchId);
    setRoleID(selectedStaff?.roleId);
    setDepartmentID(selectedStaff?.departmentId);
  }, []);
  async function handlesubmit(e) {
    setIsLoading(true);
    e.preventDefault();
    const data = {
      roleId: roleID,
      departmentId: departmentID,
      branchId: branchID,
    };

    try {
      const response = await fetch(baseUrl + "staff/" + selectedStaff.id, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (response.status === 200) {
        console.log(result);
        openToast("User Permission Updated Successfully", "success");
      } else {
        openToast("An error occurred while updating user permission", "error");
      }
    } catch (error) {
      console.error("Error updating user permission:", error);
      openToast("An error occurred while updating user permission", "error");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <div className='relative flex flex-col xl:pt-[30px] pb-[30px] w-full'>
        <div className="top-0 flex justify-between items-center bg-white shadow-cs pt-[14px] pr-[14px] pb-[14px] pl-[14px] rounded-md w-[100%]">
          <h3 className="font-medium">User Permission</h3>
          <button
            onClick={(e) => handlesubmit(e)}
            disabled={isLoading}
            className={
              "second-btn " + (isLoading && "opacity-50 cursor-not-alloweds")
            }
          >
            Update Details
          </button>
        </div>
        <form className="border-1 shadow-md m-auto mt-[10px] p-[12px] xl:p-[24px] border rounded-md w-[100%] xl:w-[100%]">
          <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[10px] w-[100%]">
            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">Roles</label>
              <br />
              <select
                defaultValue={roleID}
                value={roleID}
                onChange={(e) => {
                  const selectedRole = allRoles.find(
                    (role) => role.id === e.target.value
                  );
                  if (selectedRole) {
                    setRole(selectedRole.role_name);
                    setRoleID(selectedRole.id);
                  }
                }}
                className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none set-input-focus"
              >
                {allRoles.map((roleValue) => (
                  <option key={roleValue.id} value={roleValue.id}>
                    {roleValue.role_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">Departments</label>
              <br />
              <select
                defaultValue={departmentID}
                value={departmentID}
                onChange={(e) => {
                  const selectedDepartment = allDepartments.find(
                    (dept) => dept.id === e.target.value
                  );
                  if (selectedDepartment) {
                    setDepartment(selectedDepartment.department_name);
                    setDepartmentID(selectedDepartment.id);
                  }
                }}
                className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none set-input-focus"
              >
                {allDepartments.map((departmentValue) => (
                  <option key={departmentValue.id} value={departmentValue.id}>
                    {departmentValue.department_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">Branch</label>
              <br />
              <select
                defaultValue={branchID}
                value={branchID}
                onChange={(e) => {
                  const selectedBranch = allBranch?.find(
                    (branch) => branch?.id === e.target?.value
                  );
                  if (selectedBranch) {
                    setBranch(selectedBranch?.branchName);
                    setBranchID(selectedBranch?.id);
                  }
                }}
                className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none set-input-focus"
              >
                {allBranch?.map((branchValue) => (
                  <option key={branchValue?.id} value={branchValue?.id}>
                    {branchValue?.branchName}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default UserPermission;
